import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { contentCountsRequest } from '~src/spacesPlatform/actions/ContentCountsActions';
import { selectContentCounts, selectContentCountsUpToDate } from '~src/spacesPlatform/selectors/ContentCountsSelector';
import { selectSpaceInfo } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';

import { SessionServerSelectors } from '../../app/selectors/SessionInfoSelectors';
import { AppState } from '../../app/state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../app/utils/ConnectUtils';
import { ScheduleSpace, ScheduleSpaceDispatchProps, ScheduleSpaceStateProps } from './ScheduleSpace';

const mapStateToProps: MapStateToProps<ScheduleSpaceStateProps> = (state: AppState) => ({
  spaceInfo: selectSpaceInfo(state),
  contentCounts: selectContentCounts<'schedule'>(state, 'schedule'),
  contentCountsUpToDate: selectContentCountsUpToDate(state),
  displaySchedulesInClientTimezone: SessionServerSelectors.displaySchedulesInClientTimezone(state),
});

const mapDispatchToProps: MapDispatchToProps<ScheduleSpaceDispatchProps> =
  (dispatch) => bindActionCreators({
    fetchUpdatedContentCounts: contentCountsRequest
  },
  dispatch);

export const ConnectedScheduleSpace = connect(mapStateToProps, mapDispatchToProps)(ScheduleSpace);
